// src/components/store/sections/hero-banner/HeroV55CyberhudIndigoPulse.tsx
"use client";

import React from "react";
import DynamicHeroVariant from "./DynamicHeroVariant";

export default function HeroV55CyberhudIndigoPulse(props: any) {
  return (
    <DynamicHeroVariant
      variantNumber={55}
      archKey="cyber_hud"
      archLabel="Cyberpunk HUD Matrix"
      palName="IndigoPulse"
      grad="from-indigo-500 via-blue-600 to-violet-700"
      lightBg="bg-indigo-50"
      textCol="text-indigo-700"
      borderCol="border-indigo-200"
      btnCls="bg-indigo-600 hover:bg-indigo-700"
      {...props}
    />
  );
}
